export default __webpack_public_path__ + "static/mobile-banner-5abf8c2c507982edec98937d27dd212e.png";